import { DitherMark } from "./dither-avatar.js";

/**
 * The brand seed.
 *
 * The mark is a dither-kit avatar rather than a drawing: the glyph falls out of
 * the name through a deterministic PRNG, so `Saucer` at hue 358 is one specific
 * mirrored 8×8 pattern and will be that pattern forever. Changing either value
 * changes the logo, which is the only reason they live in one place — the
 * favicon and `public/brand.css` carry a generated copy of the same glyph, and
 * `apps/web/scripts/gen-brand-mark.mjs` regenerates them from these numbers.
 */
export const BRAND_MARK = { name: "Saucer", hue: 358 } as const;

/** The mark, at whatever size the surface wants. Decorative: every place it is
 * used has "saucer.sh" set in type beside it. */
export function SaucerMark({ size = 18 }: { size?: number }) {
  return <DitherMark name={BRAND_MARK.name} hue={BRAND_MARK.hue} size={size} />;
}
